export default __webpack_public_path__ + "static/media/MediumSBAcceptableMovementEdited.155dbd8b.png";